document.querySelectorAll('form.patient-mood-checks-form').forEach((form) => {
    const startTime = performance.now();

    form.addEventListener('submit', (e) => {
        const durationInput = document.createElement('input');
        durationInput.type = 'hidden';
        durationInput.name = 'duration';
        durationInput.value = Math.round((performance.now() - startTime) / 1000);
        form.appendChild(durationInput);
    });
});
